<template>
  <el-dialog
    :visible.sync="isShow"
    :before-close="handleClose"
    :title="title"
    width="800px">
    <div v-if="isShow">
      <FormCom
        ref="form"
        :form="form"/>
    </div>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import FormCom from '../../../components/FormComponents/index.vue';
  import fields from './fields';
  import fieldsAdd from './fieldsAdd';
  import fieldsScene from './fieldsScene';
  import * as gameManageServer from '../../../api/gameManage';

  export default {
    name: "EditScene",
    components: {
      FormCom,
    },
    props: {
      // 是否是通用场景
      isScene: {
        type: Boolean,
        default: false,
      },
      data: {
        type: [String, Number, Array, Object],
      },
      type: {
        type: [String, Number],
      },
      // 二级目录id
      parentType: {
        type: [String, Number],
      },
      isShow: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        form: this.isScene ?
                JSON.parse(JSON.stringify(fieldsScene)) :
                JSON.parse(JSON.stringify(this.isInClass ? fieldsAdd : fields)),
      };
    },
    computed: {
      // 是否是课中题目配置
      isInClass() {
        return `${this.parentType}` === '4';
      },
      title() {
        return this.data ? '编辑' : '新建';
      },
      // 获取真实需要的数据格式，如果组件有设置attr,就获取对应的value
      realData() {
        const obj = {};
        try {
          this.form[2].value.layout.map((v) => {
            if (v.config && Array.isArray(v.config)) {
              v.config.map((q) => {
                if (q.attr) {
                  switch (q.type) {
                    // 将对象中的value,如果是数组的话，存在attr就转成对象【针对评分规则】
                    case 'SelectQuestionScore': {
                      if (Object.prototype.toString.call((q.value) === '[object Object]')) {
                        obj[q.attr] = JSON.parse(JSON.stringify(q.value));
                        for (const item in obj[q.attr]) {
                          const obj1 = {};
                          if (Array.isArray(obj[q.attr][item])) {
                            obj[q.attr][item].map((k) => {
                              if (k.attr) obj1[k.attr] = this.transformInt(k.value);
                            });
                          }
                          if (Object.keys(obj1).length > 0) {
                            if (obj1.scoreMap) {
                              obj1.scoreMap = obj1.scoreMap.scoreMap;
                              obj1.scoreMap = this.json2Int(obj1.scoreMap);
                            }
                            obj[q.attr][item] = obj1;
                          }
                        }
                      }
                      break;
                    }
                    // 队列+模式
                    case 'YourselfListMode':
                      obj[q.attr] = this.getListModeConfig(q.value);
                      break;
                    // 队列
                    case 'YourselfList':
                      obj[q.attr] = this.getOneCompConfig(q.value);
                      break;
                    default:
                      obj[q.attr] = q.value;
                  }
                }
              });
            }
          });
        } catch (e) {
          console.log('获取真实数据过程失败==>', e);
        }
        return obj;
      },
    },
    watch: {
      isShow: {
        handler(vl) {
          this.form = this.isScene ? JSON.parse(JSON.stringify(fieldsScene)) : JSON.parse(JSON.stringify(this.isInClass ? fieldsAdd : fields));
        },
        deep: true,
        immediate: true,
      },
      isScene: {
        handler(vl) {
          this.form = vl ? JSON.parse(JSON.stringify(fieldsScene)) : JSON.parse(JSON.stringify(this.isInClass ? fieldsAdd : fields));
        },
        deep: true,
        immediate: true,
      },
      data: {
        handler(vl) {
          this.$nextTick(() => {
            const fn = setTimeout(() => {
              this.form.map((v) => {
                if (v.attr === 'json_config_original') {
                  v.value = JSON.parse(vl[v.attr]);
                } else if (v.attr === 'extend_field_2') {
                  v.value = vl[v.attr] === '1';
                } else {
                  v.value = vl[v.attr];
                }
              });
              clearTimeout(fn);
            });
          });
        },
        deep: true,
      },
    },
    methods: {
      // 如果对象中有数组，并且评分数组内的字符串数字全部转成纯数字
      json2Int(value) {
        const newValue = value;
        try {
          if (Object.prototype.toString.call((newValue) === '[object Object]')) {
            for (const item in newValue) {
              if (newValue[item] && Array.isArray(newValue[item]) && newValue[item].length > 0) {
                newValue[item].map((v) => {
                  v.min = this.transformInt(v.min);
                  v.max = this.transformInt(v.max);
                  v.score = this.transformInt(v.score);
                });
              }
            }
          }
        } catch (e) {
          console.log('转成数字失败==>', e);
        }
        return newValue;
      },
      // 转成纯数字
      transformInt(value) {
        let newValue = value;
        try {
          if (typeof newValue === 'string' && newValue !== '')newValue = parseInt(newValue, 10);
        } catch (e) {
          console.log('转成数字失败==>', e);
        }
        return newValue;
      },
      handleClose() {
        this.form = [];
        this.$emit("update:isShow", false);
      },
      async handleSubmit() {
        const state = this.$refs.form.validateForm();
        console.log('state==>', state);
        // 校验通过 提交表单
        if (state) {
          const obj = { type_id: parseInt(this.type, 10) };
          this.form.map((v) => {
            if (v.type === 'Layout') {
              v.options.map((q) => {
                obj[q.attr] = q.value;
              });
            } else if (v.attr === 'json_config_original') {
              obj[v.attr] = JSON.stringify(v.value);
            } else {
              obj[v.attr] = v.value;
            }
          });

          const type_id = (this.data && this.data.type_id) || null;
          obj.type_id = type_id || this.type;

          // 扩展字段【extend_field_1】存给cocos真实的数据结构
          if (this.realData && typeof this.realData === 'object') {
            obj.extend_field_1 = JSON.stringify(this.realData);
          }
          // 编辑
          if (this.data) {
            obj.id = this.data.id;
            await gameManageServer.updateGameScene(obj);
          } else {
            // 新建
            await gameManageServer.addGameScene(obj);
          }
          this.$emit('success');
          this.handleClose();
        }
      },
      // 获取队列+模式 配置数据
      getListModeConfig(data) {
        const arr = data.data;
        const obj = {};
        console.log('777-1', data, arr, 'youself');
        // arr = arr.map(v => obj[v.attr] = this.getNewCompConfig(v.value));
        const v = arr[data.curMode];
        if (v.attr)obj[v.attr] = this.getNewCompConfig(v.value);
        return obj;
      },
      // 获取组件配置
      getNewCompConfig(data) {
        let arr = data;
        const obj = {};
        console.log('777-2', arr, 'modal');
        arr = arr.map((v) => {
          console.log('777-2-1', v.value[0].attr);
          console.log('777-2-2', v.value[0].type);
          // 队列配置
          if (v.value[0].type === 'YourselfList') {
            obj[v.value[0].attr] = this.getOneCompConfig(v.value[0].value);
          } else {
            obj[v.value[0].attr] = v.value[0].value;
          }
        });
        return obj;
      },
      // 获取单个组件配置
      getOneCompConfig(data) {
        const arr = data;
        const newArr = [];
        let obj = {};
        console.log('777-3', arr, 'kai');
        arr.value && arr.value.map((v) => {
          obj = {};
          v.map((q) => {
            obj[q.attr] = q.value;
          });
          newArr.push(obj);
        });
        return newArr;
      },
    },
  };
</script>

<style scoped>

</style>
